export const NotFound = () => {
  return <>Activity Not Found. Something went wrong.</>;
};
